module.exports = __webpack_public_path__ + "static/media/ct_powerdby.da2c6d96.png";